import React from "react";
import "./style.css";

const Wrapper = () => {
  const data = [
    {
      cover: <i className="fa-solid fa-truck-fast"></i>,
      title: "Envíos a toda Argentina",
      decs: "Trabajamos con las mejores empresas para asegurar que tus productos lleguen a tiempo",
    },
    {
      cover: <i className="fa-solid fa-id-card"></i>,
      title: "Paga de forma segura",
      decs: "Aceptamos mercadoPago, tarjetas de débito, crédito, criptomonedas y transferencias bancarias",
    },
    {
      cover: <i className="fa-solid fa-shield"></i>,
      title: "Productos con garantía",
      decs: "Todos nuestros productos tienen una garantía certificadas por el fabricante",
    },
    {
      cover: <i className="fa-solid fa-headset"></i>,
      title: "Servicio técnico personalizado ",
      decs: "Servicio técnico de lunes a sábados de 9:30 a 13:00 y 16:30-20:00",
    },
  ];
  return (
    <>
      <section className="wrapper background">
        <div className="container grid2">
          {data.map((val, index) => {
            return (
              <div className="product" key={index}>
                <div className="img icon-circle">
                  <i>{val.cover}</i>
                </div>
                <h3>{val.title}</h3>
                <p>{val.decs}</p>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Wrapper;
